export default __webpack_public_path__ + "170b7c85132762e23a56e5216717e393.woff?proxy=wpt-abc";